var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentcolor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M2.708 23.292 8.72 20.98c.385-.148.577-.222.757-.319a3 3 0 0 0 .455-.296c.161-.125.307-.27.598-.562l12.22-12.22a3.064 3.064 0 0 0-4.333-4.333L6.197 15.47c-.291.291-.437.437-.562.598q-.167.215-.296.455c-.097.18-.17.372-.318.757zm0 0 2.23-5.797c.16-.415.24-.623.376-.718a.54.54 0 0 1 .41-.087c.164.032.321.189.636.503l2.447 2.447c.314.315.471.472.503.635a.54.54 0 0 1-.087.41c-.095.138-.303.218-.718.377z"
  })));
};
export default SvgPencil;